<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'中介服务管理'},{name:'中介服务列表',goback:true},{name:'中介服务明细'}]" :title="'中介服务明细'"/>
            <!-- 详情 -->
            <div class="box detailBas">
            <el-card class="basic box_card" header="基础信息" shadow="never">
                  <el-row>
                    <el-col :span="8">
                      <div class="child">
                        <div class="name">中介服务名称：</div>
                        <div class="content">{{dataInfo.name||'--'}}</div>
                    </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                        <div class="name">服务类型：</div>
                        <div class="content">{{dataInfo.serviceTypeValue||'--'}}</div>
                    </div>
                    </el-col>
                    <el-col :span="8">
                       <div class="child">
                        <div class="name">简介：</div>
						<div class="content">{{dataInfo.summary||'--'}}</div>
                    </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                        <div class="name">网址链接：</div>
                        <div class="content">{{dataInfo.websiteLink||'--'}}</div>
                    </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                        <div class="name">LOGO：</div>
                        <div class="content"><img class="logos"  :src="dataInfo.frontPath+dataInfo.logo"></div>
                    </div>
                    </el-col>
                  </el-row>
            </el-card>
            <el-card class="basic box_card mt16" header="其它信息" shadow="never">
                  <el-row>
                    <el-col :span="8">
                      <div class="child">
                        <div class="name">发布账号：</div>
                        <div class="content">{{dataInfo.createUserName||'--'}}</div>
                    </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                        <div class="name">发布时间：</div>
                        <div class="content">{{dataInfo.createTime||'--'}}</div>
                    </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                        <div class="name">更新账号：</div>
                        <div class="content">{{dataInfo.modifyUserName||'--'}}</div>
                    </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                        <div class="name">更新时间：</div>
                        <div class="content">{{dataInfo.updateTime||'--'}}</div>
                    </div>
                    </el-col>
                  </el-row>
            </el-card>
                
            </div>
        </div>
    </template>

<script>
import breadcrumb from '../../components/breadcrumb';
export default {
    components:{
        breadcrumb
    },
    data(){
        return{
            id:"",//详情
			dataInfo:'',
        }
    },
	computed: {
	    errors() {
	        return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
	    }
	},
    created(){
        if(this.$route.query.id){
            this.id=this.$route.query.id;
			this.getDetail()
        }
    },
	methods:{
		getDetail(){
			this.$axiosc.get('backstage/intermediary/details/'+this.id).then((r)=>{
			    if(r.code==200){
			        this.dataInfo=r.data;
			    }else{
			        this.$alert(r.msg)
			    }
			})
		},
	}
}
</script>

<style lang="scss" scoped>
.warp{
    height:100%;
    overflow: hidden;
    padding:0;
    background: transparent !important;
    .box{
        height:calc(100% - 40px);
    overflow-x: hidden;
    overflow-y: auto;
    }
}
.box{
    // margin-top: 20px;
    &_card{
      border:none;
      &::v-deep{
        .el-card__header{
          font-size: 16px;
          color: #262626;
          padding:14px 22px !important;
          border-bottom-color:#E5E5E5;
        }
        .el-card__body{
          padding:24px 25px !important;
        }
      }
    }
    .tableChild{
      margin-top:8px !important;
    }
    .child,.attachment{
      margin-top:8px;
    }
}
</style>